import React from 'react';
import Literaryclub2023 from 'views/Literaryclub2023';

const LifeSkillPage = () => {
  return <Literaryclub2023/>;
};

export default LifeSkillPage;